import React from 'react'
import { useSelector } from 'react-redux'

import {
  SignInWithProvider,
  LookingToJoin,
  Main,
  LegalText,
  HorizontalRule,
} from '../../../../components'
import { EmailFormLayout } from './EmailForm'
import { SSOProviders } from 'components/SSOProviders'
import { getTemplateChannelToken } from '../state'
import { useAnalytics } from 'hooks/useAnalytics'
import { useGoogleOneTap } from '../../../../hooks/useGoogleOneTap'
import { FormattedMessage } from 'react-intl'

export function Start({ superEnabled }: { superEnabled: boolean }) {
  const track = useAnalytics()
  const templateChannelToken = useSelector(getTemplateChannelToken)

  const onClick = (signUpMethod: SSOProviders, callback: () => void) => {
    switch (signUpMethod) {
      case SSOProviders.Google:
        track('ONBOARDING_CREATE_START_GOOGLE_SIGNUP')
        break
      case SSOProviders.Slack:
        track('ONBOARDING_CREATE_START_SLACK_SIGNUP')
        break
      case SSOProviders.Apple:
        track('ONBOARDING_CREATE_START_APPLE_SIGNUP')
        break
      default:
        throw new Error(`Unknown sign up method ${signUpMethod}`)
    }
    setTimeout(() => {
      callback()
    }, 300) // Delay redirection by 300ms - recommended by Segment
  }

  useGoogleOneTap(superEnabled ? 'org/super/create' : 'org/slite/create')

  return (
    <>
      <Main.Container footer={<LookingToJoin superEnabled={superEnabled} />}>
        <Main.Title className="margin-bottom-32">
          <FormattedMessage
            id="boarding.create.account.title"
            defaultMessage="Create your account"
            values={{}}
          />
        </Main.Title>
        <SignInWithProvider
          provider={SSOProviders.Google}
          onClick={(callback) => onClick(SSOProviders.Google, callback)}
          className="margin-bottom-12"
          channelToken={templateChannelToken}
          superEnabled={superEnabled}
        />
        <SignInWithProvider
          provider={SSOProviders.Apple}
          onClick={(callback) => onClick(SSOProviders.Apple, callback)}
          className="margin-bottom-12"
          channelToken={templateChannelToken}
          superEnabled={superEnabled}
        />
        <SignInWithProvider
          provider={SSOProviders.Slack}
          onClick={(callback) => onClick(SSOProviders.Slack, callback)}
          channelToken={templateChannelToken}
          superEnabled={superEnabled}
        />

        <HorizontalRule />

        <EmailFormLayout superEnabled={superEnabled} />

        <LegalText className="margin-top-24" />
      </Main.Container>
    </>
  )
}
